import Lottie from 'react-lottie-player';

const CustomLottie = (props: {
  path?: string;
  className: string;
  loop?: boolean | number;
  onLoadComplete?: () => void;
  animationData?: { ['default']: object } | object;
}) => {
  return (
    <div className={`overflow-hidden ${props.className}`}>
      <Lottie
        loop={props.loop ?? false}
        path={props.path}
        animationData={props.animationData}
        play
        onComplete={props.onLoadComplete}
      />
    </div>
  );
};
export default CustomLottie;
